const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function getStayDisplayDates(stay: {
  checkInDate: string;
  checkOutDate?: string | null;
  checkedInAt?: string | null;
  checkedOutAt?: string | null;
}) {
  // Preserve the calendar date supplied by the API for actual arrivals and
  // departures, just as we do for scheduled date-only values.
  const actualDate = (value: string | null | undefined) =>
    value?.trim().match(/^(\d{4}-\d{2}-\d{2})/)?.[1];

  return {
    checkIn: actualDate(stay.checkedInAt) ?? stay.checkInDate,
    checkOut: actualDate(stay.checkedOutAt) ?? stay.checkOutDate ?? null,
  };
}

export function toDisplayDate(value: string): Date {
  if (DATE_ONLY_RE.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  return new Date(value);
}

export function formatShortDisplayDate(value: string): string {
  return toDisplayDate(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

export function formatStayRange(
  checkInDate: string,
  checkOutDate: string | null,
): string {
  return checkOutDate
    ? `${formatShortDisplayDate(checkInDate)} – ${formatShortDisplayDate(
        checkOutDate,
      )}`
    : `${formatShortDisplayDate(checkInDate)} – Open`;
}
